var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerShape01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 231,
    viewBox: "0 0 257 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.145 -42.2868C147.521 -65.277 171.03 -73.1499 191.059 -74.9371C219.796 -77.4972 245.962 -68.3555 253.552 -36.8708C254.986 -30.9082 255.681 -23.7741 253.097 -15.2733C249.063 -2.01019 238.534 10.1871 228.918 19.2722C204.964 41.9127 180.374 56.4816 156.474 69.1958C134.214 81.0402 112.161 91.5861 90.3168 100.834C73.2705 108.066 56.0439 114.517 41.5254 113.605C39.4495 113.471 37.2643 112.995 36.9782 110.307C36.8647 108.516 37.38 106.279 38.4174 104.057C42.5566 94.7514 50.8342 89.4109 57.3335 86.7638C90.046 73.5539 115.652 84.4295 134.182 103.696C140.129 109.89 145.695 117.799 144.404 131.357C142.685 149.565 128.509 172.55 113.942 186.157C99.3748 199.765 84.6059 205.923 70.6481 210.782C35.4428 222.991 1.8275 229.176 -29.4732 229.201",
    stroke: "#E1DAF1",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerShape01);
export default __webpack_public_path__ + "static/media/banner_shape01.2e6375b94e4b80466eda821b50a40e5a.svg";
export { ForwardRef as ReactComponent };